<template>
  <div>
    <v-toolbar flat color="white" class="pt-3">
      <v-btn v-if="organisationDetail&&organisationDetail.isActive" round color="light-green" class="white--text" @click="changeActiveStatus()">Active</v-btn>
      <v-btn v-else round color="red" class="white--text" @click="changeActiveStatus()">Inactive</v-btn>

      <h2 class="dark-grey--text px-2">{{organisationDetail.name}}</h2>
      <v-spacer></v-spacer>
      <v-btn
        round
        color="primary"
        v-if="displayContents('info')"
        @click="saveInfoChanges"
      >Save Info Changes</v-btn>
      <v-btn
        round
        color="primary"
        v-if="displayContents('modules')"
        @click="saveModuleChanges"
      >Save Module Changes</v-btn>
    </v-toolbar>

    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>

    <div v-if="displayContents('info')">
      <v-flex xs12>
        <v-card flat color="white">
          <h2 class="grey--text">Organisation Info</h2>
          <v-card-text>
            <v-layout justify-left align-center wrap>
              <v-flex xs4 mx-1>
                <v-text-field label="Organisation Name" v-model="organisationDetail.name"></v-text-field>
                <v-select
                  :items="organisationTypes"
                  item-text="name"
                  item-value="id"
                  label="Organisation Type"
                  v-model="organisationDetail.organisationTypeId"
                ></v-select>
              </v-flex>
              <v-flex xs6 ml-1>
                <v-img contain max-height="150px" :src="organisationDetail.logo"></v-img>
              </v-flex>
              <v-flex xs5 mx-1>
                <v-textarea
                auto-grow
                  label="Description"
                  v-model="organisationDetail.description"
                ></v-textarea>
              </v-flex>
              
              <!-- <v-flex xs5 mx-1>
                <v-layout>
                  <v-switch 
                  label="Customer"
                  v-model="organisationDetail.isCustomer"
                ></v-switch>
                <v-switch 
                  label="Supplier"
                  v-model="organisationDetail.isSupplier"
                ></v-switch>
                </v-layout>
                
              </v-flex> -->
              <v-flex xs12><h2 class="grey--text">Contact Information</h2></v-flex>
              <!-- <v-flex xs5 mx-1> <span class="font-weight-bold grey--text">Sales Email Address:</span> <span class="grey--text">  {{organisationDetail.salesEmailAddress}}</span>  </v-flex> -->
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4>
                    <span class="subheading grey--text">Billing Email Address:</span>
                  </v-flex>
                  <v-flex xs7 mx-1>
                    <span class="grey--text">{{organisationDetail.billingEmailAddress}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4>
                    <span class="subheading grey--text">Sales Email Address:</span>
                  </v-flex>
                  <v-flex xs7 mx-1>
                    <span class="grey--text text-xs-left">{{organisationDetail.salesEmailAddress}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4 >
                    <span class="subheading grey--text">Website URL:</span>
                  </v-flex>
                  <v-flex xs7 mx-1>
                    <span class="grey--text">{{organisationDetail.websiteUrl}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4>
                    <span class="subheading grey--text">T's & C's Link:</span>
                  </v-flex>
                  <v-flex xs7 mx-1>
                    <span class="grey--text">{{organisationDetail.termsAndConditionsLink}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4 >
                    <span class="subheading grey--text">FUP URL:</span>
                  </v-flex>
                  <v-flex xs7 mx-1>
                    <span class="grey--text">{{organisationDetail.fupUrl}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 mt-2>
                <h2 class="text-xs-center grey--text">Customer Support</h2>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4 >
                    <span class="subheading grey--text">Email:</span>
                  </v-flex>
                  <v-flex xs7 mx-1>
                    <span class="grey--text">{{organisationDetail.customerSupportEmail}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4 >
                    <span class="subheading grey--text">Contact Number:</span>
                  </v-flex>
                  <v-flex xs7 mx-1>
                    <span class="grey--text">{{organisationDetail.customerSupportTelephone}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4 >
                    <span class="subheading grey--text">Whatsapp number:</span>
                  </v-flex>
                  <v-flex xs7 mx-1>
                    <span class="grey--text">{{organisationDetail.customerSupportWhatsapp}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4 >
                    <span class="subheading grey--text">Description (eg operating times etc):</span>
                  </v-flex>
                  <v-flex xs7 mx-1>
                    <span class="grey--text">{{organisationDetail.customerSupportDescription}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
               <v-flex xs12 mt-2>
                <h2 class="text-xs-center grey--text">Address Information</h2>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4 >
                    <span class="subheading grey--text">Physical Address Line 1:</span>
                  </v-flex>
                  <v-flex xs7>
                    <span class="grey--text">{{organisationDetail.physicalAddressLine1}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4 >
                    <span class="subheading grey--text">Physical Address Line 2:</span>
                  </v-flex>
                  <v-flex xs7 >
                    <span class="grey--text">{{organisationDetail.physicalAddressLine2}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4 >
                    <span class="subheading grey--text">Physical Address Line 3:</span>
                  </v-flex>
                  <v-flex xs7 >
                    <span class="grey--text">{{organisationDetail.physicalAddressLine3}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
                <v-flex xs6>
                   <v-layout justify-left align-center row wrap class="text-xs-left">
                  <v-flex xs4 >
                    <span class="subheading grey--text">Physical Address Line 4:</span>
                  </v-flex>
                  <v-flex xs7 >
                    <span class="grey--text">{{organisationDetail.physicalAddressLine4}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>

              <!-- <v-flex xs6>
                <v-autocomplete
                  :items="allBills"
                  item-text="bill_name"
                  item-value="bill_id"
                  label="Libre NMS Bill"
                  v-model="organisationDetail.libreBillId"
                ></v-autocomplete>
              </v-flex> -->
              <!-- <v-flex xs6>
                <v-text-field
                  label="Layer 2 Rate per Mbps"
                  v-model="organisationDetail.layerTwoRate"
                ></v-text-field>
              </v-flex> -->
              <!-- <v-flex xs6>
                <v-autocomplete
                  label="Xero Contact"
                  :items="allXeroContacts"
                  item-text="Name"
                  item-value="ContactID"
                  v-model="organisationDetail.xeroContactId"
                ></v-autocomplete>
              </v-flex> -->
              <!-- <v-flex xs4 mx-1>
                <v-textarea disabled auto-grow label="Token" v-model="organisationDetail.token"></v-textarea>
              </v-flex> -->
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </div>
    <div v-if="displayContents('modules')">
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="allModules"
        :rows-per-page-items="[25, 50, 100, 250]"
        v-model="modules"
        item-key="id"
        align-center
        select-all
      >
        <template v-slot:items="props">
          <!-- <td class="text-xs-center">
            <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td>-->
          <td>
            <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td
            class="text-xs-center"
          >{{props.item.description}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </div>

    <div v-if="displayContents('users')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn round color="primary" @click="attachContactModal=true">Add Contact to Organisation</v-btn>
      </v-toolbar>
      <v-data-table
      :headers="userHeaders"
      :items="organisationUsers"
      :rows-per-page-items="[25, 50, 100, 250]"
      item-key="id"
      class="elevation-1"
      >
      <template v-slot:items="props">
        <td class="text-xs-center"><v-icon v-if="props.item.userType != 'systemAdmin'" color="red" @click="removeContactFromOrg(props.item)">remove_circle</v-icon></td>
      <td class="text-xs-center">{{props.item.name}}</td>
      <td class="text-xs-center">{{props.item.surname}}</td>
      <td class="text-xs-center">{{props.item.idNumber}}</td>
      <td class="text-xs-center" ><v-select :items="contactTypes" item-value="id" item-text="name" @change="selectContactType(props.item)" v-model="props.item.contactType" ></v-select></td>
      <td class="text-xs-center">{{props.item.userType}}</td>
      </template>
      <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </div>

    <div v-if="displayContents('technical')">
      <v-toolbar flat color="white"> <v-spacer></v-spacer><v-btn round color="primary" class="white--text" @click="addBridgeModal()">Add Template</v-btn></v-toolbar>
      <v-data-table
        :headers="templateHeaders"
        class="elevation-1"
        :items="organisationBridgeTemplates"
        :rows-per-page-items="[25, 50, 100, 250]"
        item-key="id"
        align-center
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-layout justify-center align-center>
            <v-icon small @click="editBridgeModal(props.item)">edit</v-icon>
            <v-icon small @click="deleteBridgeItem(props.item)">delete</v-icon>

            </v-layout>
          </td>
          <td class="text-xs-center">{{props.item.deviceMake.name}}</td>
          <td class="text-xs-center">{{props.item.bridgeTemplateName}}</td>
          <td class="text-xs-center">{{props.item.gponTrafficIndex}}</td>
          <td class="text-xs-center">{{props.item.innerVlan}}</td>
          <td class="text-xs-center">{{props.item.outerVlan}}</td>
          <td class="text-xs-center">
            <v-icon v-if="props.item.autoSelectGemPortValue" color="light-green">done</v-icon>
            <v-icon v-else color="red" >clear</v-icon></td>        
          <td class="text-xs-center" v-if="props.item.rgMode">{{rgModeArray.find(x=>x.id===props.item.rgMode).name}}</td>
          <td v-else></td>
         
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </div>
    <!-- Add Bridge Modal-->

       <v-dialog v-model="addBridgeItem" max-width="750px" persistent>
          <v-card flat color="white">
              <v-toolbar flat class="primary">
        <h1 class="headline white--text" >{{item.type}} Bridge Template</h1>
        <v-spacer></v-spacer>
        <v-btn flat color="white" class="white--text" @click="addBridgeItem=false, item={}">X</v-btn>
        </v-toolbar>
            <v-card-text>
              <v-layout justify-center>
                <v-flex xs6>
                  <v-autocomplete v-if="item.type=='Add'" :items="deviceMakes.filter(x=>!organisationBridgeTemplates.map(y=>y.deviceMakeId).includes(x.id))" v-model="item.deviceMakeId" item-text="name" item-value="id" label="Select a brand to apply settings to:"></v-autocomplete>
                  <v-autocomplete v-else-if="item.type=='Edit'" :items="deviceMakes.filter(x=>!organisationBridgeTemplates.map(y=>y.deviceMakeId).includes(x.id)||x.id == item.deviceMakeId)" v-model="item.deviceMakeId" item-text="name" item-value="id" label="Select a brand to apply settings to:"></v-autocomplete>

                </v-flex>
                <v-flex xs3><span><i>*Please not that only one template may be applied per brand per customer.</i></span></v-flex>
              </v-layout>
              <v-flex v-if="item.deviceMakeId&&deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Zhone'">
                <!-- Port Info -->
                <v-layout justify-center>
                    <v-flex xs12>
                        <h3>Port</h3>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs6 mx-1>
                        <v-checkbox label="Auto Select Gem Port ID" v-model="item.autoSelectGemPortValue"></v-checkbox>
                </v-flex>
                    <v-flex xs6 mx-1>
                        <v-autocomplete v-model="item.gponTrafficIndex" :items="zhoneTrafficProfiles" label="GTP Index" item-text="name" item-value="name"></v-autocomplete>
                    </v-flex>
                </v-layout>

                <!-- GTP Info -->

                <v-layout justify-center>
                    <v-flex xs12>
                        <h3>Bridge Logical</h3>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs4>
                        <v-autocomplete :items="bridgeTemplates" v-model="item.bridgeTemplateName" item-text="name" item-value="name" label="Bridge Logical Template"></v-autocomplete>
                    </v-flex>
                    <v-flex xs4 mx-1>
                    <v-autocomplete :items="vlanArray"  type="number" :min="0" v-model="item.outerVlan" label="Outer Vlan"></v-autocomplete>
                </v-flex>
                  <v-flex xs4 mx-1>
                    <v-autocomplete  :items="vlanArray" :min="0" v-model="item.innerVlan" label="Inner Vlan"></v-autocomplete>
                </v-flex>
                </v-layout>

                <v-layout justify-center>
                    <v-flex xs12>
                        <h3>CPE Connection</h3>
                    </v-flex>
                </v-layout>
                 <v-layout>
                    <v-flex xs6 mx-1>
                    <v-autocomplete :items="tpTypeArray" item-text="name" item-value="id"  v-model="item.tpType" label="Type"></v-autocomplete>
                </v-flex>
                      <v-flex xs6 mx-1>
                    <v-autocomplete :items="ports" chips v-model="item.tpIndex" label="Ethernet Port"></v-autocomplete>
                </v-flex>
                </v-layout>
                 <v-layout>
               <v-flex xs6 mx-1>
                    <v-autocomplete :items="rgModeArray" item-text="name" item-value="id"  v-model="item.rgMode" label="RG Mode"></v-autocomplete>
                </v-flex>
               <v-flex xs4 mx-1>
                    <v-autocomplete  :items="vlanArray" :min="0" v-model="item.uniVlan" label="Uni Vlan"></v-autocomplete>
                </v-flex>
                <v-flex xs4 mx-1>
                    <v-autocomplete  :items="vlanArray" :min="0" v-model="item.uniSlan" label="Uni Slan"></v-autocomplete>
                </v-flex>

                 <v-flex xs8 mx-1>
                  <v-checkbox label="Billable VLAN" v-model="item.isBillable"></v-checkbox>
                </v-flex>
               
                </v-layout>
                
              </v-flex>

              <v-flex v-else-if="item.deviceMakeId&&deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Huawei'">
                 <v-layout justify-center>
                    <v-flex xs12>
                        <h3>CPE Connection</h3>
                    </v-flex>
                </v-layout>
                 <v-layout justify-center wrap>
                    <v-flex xs6 mx-1>
                      <v-autocomplete  :items="vlanArray" :min="0" v-model="item.innerVlan" label="Vlan"></v-autocomplete>
                </v-flex>
                  <v-flex xs8 mx-1>
                    <v-layout>
                      <v-switch v-model="item.port_1" label="Port 1"></v-switch>
                    <v-switch v-model="item.port_2" label="Port 2"></v-switch>
                    <v-switch v-model="item.port_3" label="Port 3"></v-switch>
                    <v-switch v-model="item.port_4" label="Port 4"></v-switch>
                    </v-layout>
                    

                    <!-- <v-autocomplete :items="ports" chips multiple v-model="item.tpIndex" label="Ethernet Port(s)"></v-autocomplete> -->
                </v-flex>
                <v-flex xs8 mx-1>
                  <v-checkbox label="Billable VLAN" v-model="item.isBillable"></v-checkbox>
                </v-flex>
                </v-layout>
              </v-flex>
                
               
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn v-if="item.type=='Add'&&item.deviceMakeId&&deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Zhone'&&item.tpType&&item.deviceMakeId&&item.bridgeTemplateName&&item.rgMode&&item.gponTrafficIndex" class="primary white--text" round @click="saveBridgeItem()">Save Template</v-btn>
                    <v-btn v-else-if="item.type=='Edit'&&item.deviceMakeId&&deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Zhone'&&item.tpType&&item.deviceMakeId&&item.bridgeTemplateName&&item.rgMode&&item.gponTrafficIndex" class="primary white--text" round @click="updateBridgeItem()">Save Template</v-btn>
                    <v-btn v-else-if="item.type=='Add'&&item.deviceMakeId&&deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Huawei'&&item.innerVlan != 0" class="primary white--text" round @click="saveBridgeItem()">Save Template</v-btn>
                    <v-btn v-else-if="item.type=='Edit'&&item.deviceMakeId&&deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Huawei'&&item.innerVlan != 0" class="primary white--text" round @click="updateBridgeItem()">Save Template</v-btn>
                    <v-btn v-else-if="item.type=='Add'&&item.deviceMakeId&&((deviceMakes.find(x=>x.id===item.deviceMakeId).name=='MikroTik') || (deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Mikrotik'))"  class="primary white--text" round @click="saveBridgeItem()">Save Template</v-btn>
                    <v-btn v-else-if="item.type=='Edit'&&item.deviceMakeId&&((deviceMakes.find(x=>x.id===item.deviceMakeId).name=='MikroTik') || (deviceMakes.find(x=>x.id===item.deviceMakeId).name=='Mikrotik'))"  class="primary white--text" round @click="updateBridgeItem()">Save Template</v-btn>
                    <v-btn v-else disabled class="primary white--text" round >Save Template</v-btn>
                </v-layout>
            </v-card-actions>
          </v-card>
      </v-dialog>

     <v-dialog persistent v-model="attachContactModal" max-width="900px">
        <v-card>
          <v-toolbar flat color="primary">
            <h1 class="headline white--text">ADD CONTACT TO ORGANISATION</h1>
          </v-toolbar>
             <v-layout>
              <v-flex xs6 mx-3>
            <v-autocomplete
              clearable
              hide-no-data
              flat
              color="primary"
              v-model="contact.userType"
              :items="userTypes"
              item-text="name"
              item-value="id"
              label="*Select User Type"
              class="pt-4"
              persistent-hint
            ></v-autocomplete>
              </v-flex>
              <v-flex xs6 mx-3>
             <v-autocomplete
              clearable
              hide-no-data
              flat
              color="primary"
              v-model="contact.contactType"
              :items="contactTypes"
              item-text="name"
              item-value="id"
              label="*Select Contact Type"
              class="pt-4"
              persistent-hint
            ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-spacer></v-spacer>
            <v-text-field
              v-show="contact.userType&&contact.contactType"
              v-model="searchContacts"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              max-width="50px"
              class="pa-3"
            ></v-text-field>
            </v-layout>
        <v-data-table
          v-if="contact.userType&&contact.contactType"
          :search="searchContacts"
          :headers="contactHeaders"
          class="elevation-1"
          :rows-per-page-items="[10, 25, 50, 100]"
          :items="allContacts"
          item-key="id"
          align-center
        >
            <template v-slot:items="props">
              <td class="justify-center layout px-0">
                <v-icon
                v-if="!organisationUsers.map(x=>x.contactId).includes(props.item.id)"
                  class="mr-2"
                  @click="addOrganisationContact(props.item)"
                  color="primary"
                >add_circle_outline</v-icon>
                <!-- <v-icon small @click="deleteItem(props.item.id)">delete</v-icon> -->
              </td>
              <td class="text-xs-center">{{props.item.name}}</td>
              <td class="text-xs-center">{{props.item.surname}}</td>
              <td class="text-xs-center">{{props.item.idNumber}}</td>
              <td class="text-xs-center">{{props.item.mobileNumber}}</td>
              <td class="text-xs-center">{{props.item.telephoneNumber}}</td>
              <td class="text-xs-center">{{props.item.emailAddress}}</td>
            </template>
            <template
              v-slot:pageText="props"
            >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
          </v-data-table>

          <v-card-actions class="justify-center layout px-0">
            <v-btn
              color="primary"
              round
              @click="attachContactModal=false"
            >Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


  </div>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      contactTypes:[],
      organisationDetail: null,
      modules: [],
      foreignKey: [],
      initialModules: [],
      userTypes:["systemUser", "organisationAdmin"],
      allModules: [],
      organisationTypes: [],
      organisationUsers: [],
      primaryColour: "#a6aba8",
      secondaryColour: '#a6aba8',
      activeTabName: "",
      attachContactModal: false,
      addContactModal: false,
      contact: {},
      contactUserType: null,
      contacts:[],
      allContacts: null,
      apiUrl: null,
      apiToken: null,
      allBills: [],
      allXeroContacts: [],
      searchContacts: '',
      organisationBridgeTemplates: [],
      item: {},
      ports: ['1', '2', '3', '4'],
      selectedPorts: [],
       addBridgeItem: false,
        vlanArray: this.range(0, 4096),
        bridgeTemplates: [],
        zhoneTrafficProfiles: [],
        deviceMakes: [],
        rgModeArray:[
            {id: 1, name: 'Routed'},
            {id: 2, name: 'BRouted'},
            {id: 3, name: 'rPPPoE'},
            {id: 4, name: 'bPPPoE'},
            {id: 5, name: 'Bridged'},
            {id: 6, name: 'Not Applicable'}

        ],
        tpTypeArray: [
            {id: 1, name: 'Ethernet UNI'},
            {id: 2, name: 'VCC Termination Point'},
            {id: 3, name: 'Mapper Service Profile'},
            {id: 4, name: 'IP Host Config Data'},
            {id: 5, name: 'GEM Interworking Termination Point'},
            {id: 6, name: 'Multicast GEM Interworking Termination Point'},
            {id: 7, name: 'xDSL UNI'},
            {id: 8, name: 'VDSL UNI'},
            {id: 9, name: 'Ether Flow Termination Point'},
            {id: 10, name: 'Physical Path UNI'},
            {id: 11, name: 'Physical Path RF Video UNI'},
            {id: 12, name: 'Physical Path IPTV UNI'},
            {id: 13, name: 'H248 Voice'},
            {id: 14, name: 'SIP Voice'},
            {id: 15, name: 'SIP PLAR Voice'},
            {id: 16, name: 'PWE Termination'},
            {id: 17, name: 'Virtual Ethernet'},
            {id: 18, name: 'dot11 Termination Point'},
            {id: 19, name: 'Fiber LAN Termination Point'},
            {id: 20, name: 'TR69 Termination Point'},
            {id: 21, name: 'Management Termination Point'},
            {id: 22, name: 'MGCP Voice Termination Point'}
        ],
      tabs: [
        { name: "info", displayName: "Information" },
        { name: "modules", displayName: "Modules" },
        { name: "users", displayName: "Users" }
      ],
      userHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Surname",
          align: "center",
          value: "surname"
        },
        {
          text: "ID Number",
          align: "center",
          value: "idNumber"
        },
            {
          text: "Contact Type",
          align: "center",
          value: "contactType",
          width: "120px"
        },
        {
          text: "User Type",
          align: "center",
          value: "userType"
        }
      ],
      headers: [
        //         {
        //   text: "Action",
        //   align: "center"
        // },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        }
      ],
      templateHeaders: [
                {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Device Make",
          align: "center",
          value: "deviceMake.name"
        },
        {
          text: "Bridge Template Name",
          align: "center",
          value: "name"
        },
        {
          text: "GTP Index",
          align: "center",
          value: "gponTrafficIndex"
        },
         {
          text: "Inner VLAN",
          align: "center",
          value: "innerVlan"
        },
        {
          text: "Outer VLAN",
          align: "center",
          value: "outerVlan"
        },
        {
          text: "Auto Select GEM Port",
          align: "center",
          value: "autoSelectGemPortValue"
        },
        {
          text: "RG Mode",
          align: "center",
          value: "rgMode"
        }
      ],
      contactHeaders: [
        {
          text: "Actions",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Surname",
          align: "center",
          value: "surname"
        },
        {
          text: "ID Number",
          align: "center",
          value: "idNumber"
        },
        {
          text: "Mobile",
          align: "center",
          value: "mobileNumber"
        },
        {
          text: "Telephone",
          align: "center",
          value: "telephoneNumber"
        },
        {
          text: "Email",
          align: "center",
          value: "emailAddress"
        }
      ]
    };
  },

  created() {
    this.initialize();
    this.setActiveTabName("info");
  },
  async mounted() {
    this.setActiveTabName("info");
  },

  methods: {
     selectContactType(item){
 Api().put('/organisationContact/' + item.id,{
   contactTypeId: item.contactType
 })
    },
     async getAllBills(){
        await Api()
      .get('/integrations/byName/LibreNMS')
      .then(async response=>{
        this.apiUrl=response.data.apiUrl
        this.apiToken=response.data.token
        await Api()
        .get('/libre/allBills',{
          params: {
            apiUrl: this.apiUrl,
            apiToken: this.apiToken
          }
        }).then(response=>{
            this.allBills= response.data.bills
        })
        })
        },
    fetchOrgUserRoles(){
      Api()
      .get('/userRole')
      .then(response=>{
        this.userRole=response.data
      })
    },
    addOrganisationContact(item){
      console.log(item)
      Api()
      .post('/organisationContact/subOrganisation',{
        organisationId: this.$route.params.organisationId,
        contactId: item.id,
        userType: this.contact.userType,
        isActive: true,
        isDeleted: false,
        contactTypeId: this.contact.contactType
      }).then(response=>{
        if(this.contact.userType==='organisationAdmin'){
          for(let i=0; i<this.organisationUserRoles.length;i++){
            if(this.organisationUserRoles[i].isAdmin){
              Api()
              .post('/userRoleContact/subOrganisation',{
                organisationId: this.$route.params.organisationId,
                contactId: item.id,
                userRoleId: this.organisationUserRoles[i].id,
                isActive: true,
                isDeleted: false
              })
            }
        }
        }
        this.fetchOrganisationInfo()
        this.contact = {};
        this.attachContactModal=false
      })
    },
    async addBridgeModal(){
              this.item={
                  type: 'Add',
                  deviceMakeId: null,
                  autoSelectGemPortValue: false,
                  innerVlan: 0,
                  outerVlan: 0,
                  uniVlan: 0,
                  uniSlan: 0,
                  // tpType: 1,
                  // tpIndex: 1,
                  // rgMode: 6,
                  // gponPortId: 0,
                  // gponTrafficIndex: "1100000000",
                  // bridgeTemplateName: "DownlinkSingleTagged",
                  customerOrganisationId: this.$route.params.organisationId,
                  port_1:  false,
                  port_2:  false,
                  port_3:  false,
                  port_4:  false,
                  isBillable: true
              }
              this.addBridgeItem=true
        },
        async editBridgeModal(item){
          // this.selectedPorts = []
          // if(item.tpIndex!=null){
          // this.selectedPorts = item.tpIndex.split(',')
          // }
              this.item={
                  type: 'Edit',
                  id: item.id,
                  deviceMakeId: item.deviceMakeId,
                  autoSelectGemPortValue: item.autoSelectGemPortValue,
                  innerVlan: item.innerVlan,
                  outerVlan: item.outerVlan,
                  uniVlan: item.uniVlan,
                  uniSlan: item.uniSlan,
                  tpType: item.tpType,
                  tpIndex: item.tpIndex,
                  rgMode: item.rgMode,
                  gponTrafficIndex: item.gponTrafficIndex,
                  bridgeTemplateName: item.bridgeTemplateName,
                  customerOrganisationId: this.$route.params.organisationId,
                  port_1:  item.port_1,
                  port_2:  item.port_2,
                  port_3:  item.port_3,
                  port_4:  item.port_4
              }
              this.addBridgeItem=true
        },
        range(start, end) {
        return Array(end - start + 1).fill().map((_, idx) => start + idx)
        },
    fetchModules() {
      Api()
        .get("/modules/supplier")
        .then(response => {
          this.allModules = response.data;
        });
    },
    fetchAllContacts(){
      Api()
      .get('/contacts')
      .then(response=>{
        this.allContacts=response.data
      })
    },
    changeActiveStatus(){
      this.organisationDetail.isActive = !this.organisationDetail.isActive
    Api()
      .put('/customer/organisation/'+this.organisationDetail.id,{
        isActive: this.organisationDetail.isActive
      })
    },
    fetchOrganisationInfo() {
      this.modules = [];
      this.initialModules = [];
      this.foreignKey = [];
      this.organisationUsers=[]
      Api()
        .get("/organisation/" + this.$route.params.organisationId)
        .then(response => {
          this.organisationDetail = response.data;
          for(let y =0; y< this.organisationDetail.organisationContacts.length;y++){
            if(!this.organisationDetail.organisationContacts[y].contact.isHidden&&this.organisationDetail.organisationContacts[y].isActive&&!this.organisationDetail.organisationContacts[y].isDeleted){
              this.organisationUsers.push({
                id: this.organisationDetail.organisationContacts[y].id,
              contactId:this.organisationDetail.organisationContacts[y].contactId,
              name:this.organisationDetail.organisationContacts[y].contact.name,
              surname:this.organisationDetail.organisationContacts[y].contact.surname,
              idNumber:this.organisationDetail.organisationContacts[y].contact.idNumber,
              userType:this.organisationDetail.organisationContacts[y].userType,
              contactType:this.organisationDetail.organisationContacts[y].contactTypeId
              })
            }
          }
          // this.organisationUsers=response.data.organisationContacts
          let organisationModules = response.data.organisationModules;
          for (let i = 0; i < organisationModules.length; i++) {
            if (!organisationModules[i].isDeleted) {
              this.modules.push(organisationModules[i].module);
              this.initialModules.push(organisationModules[i].module);
              this.foreignKey.push({
                id: organisationModules[i].id,
                moduleId: organisationModules[i].module.id
              });
            }
          }
        });
    },
    getOrgTypes() {
      Api()
        .get("/customer/organisationType")
        .then(response => {
          this.organisationTypes = response.data;
        });
    },
    saveInfoChanges() {
      Api().put("/customer/organisation/"+this.$route.params.organisationId, {
        name: this.organisationDetail.name,
        description: this.organisationDetail.description,
        organisationTypeId: this.organisationDetail.organisationTypeId,
        libreBillId: this.organisationDetail.libreBillId,
        layerTwoRate: this.organisationDetail.layerTwoRate,
        xeroContactId: this.organisationDetail.xeroContactId,
        token: this.organisationDetail.token,
        logo: this.organisationDetail.logo,
        primaryColour: this.primaryColour.hex,
        secondaryColour: this.secondaryColour.hex,
        isCustomer: this.organisationDetail.isCustomer,
        isSupplier: this.organisationDetail.isSupplier
      });
    },
    fetchUserRoles(){
      Api()
      .get('/userRole/byOrg/'+this.$route.params.organisationId)
      .then(response=>{
        this.organisationUserRoles=response.data
      })
    },
    getAllXeroContacts(){
      Api()
      .get('/xero/allContacts')
      .then(response=>{
        this.allXeroContacts=response.data
      })
    },
    async saveModuleChanges() {
      for (let i = 0; i < this.modules.length; i++) {
        if (this.initialModules.indexOf(this.modules[i]) === -1) {
          await Api().post("/organisationModule", {
            moduleId: this.modules[i].id,
            organisationId: this.$route.params.organisationId,
            isActive: true,
            isDeleted: false
          }).then(async response=>{
            for (let x=0;x<this.modules[i].moduleSubmodules.length;x++){
              if(this.modules[i].moduleSubmodules[x].isActive&&!this.modules[i].moduleSubmodules[x].isDeleted&&
              // this.modules[i].moduleSubmodules[x].module.isActive&&!this.modules[i].moduleSubmodules[x].module.isDeleted&&
              this.modules[i].moduleSubmodules[x].submodule.isActive&&!this.modules[i].moduleSubmodules[x].submodule.isDeleted){
                // Organisation User Roles - add permissions
                for(let c=0;c<this.organisationUserRoles.length;c++){
                  if(this.organisationUserRoles[c].isAdmin){
                    Api()
                  .post('/routePermission',{
                    moduleSubmoduleId: this.modules[i].moduleSubmodules[x].id,
                    userRoleId: this.organisationUserRoles[c].id,
                    create: true,
                    read: true,
                    update: true,
                    delete: true,
                    organisationId: this.$route.params.organisationId,
                    isActive: true,
                    isDeleted: false
                  })
                  } else {
                    Api()
                  .post('/routePermission',{
                    moduleSubmoduleId: this.modules[i].moduleSubmodules[x].id,
                    userRoleId: this.organisationUserRoles[c].id,
                    create: false,
                    read: false,
                    update: false,
                    delete: false,
                    organisationId: this.$route.params.organisationId,
                    isActive: true,
                    isDeleted: false
                  })
                  }
                }
              }
            }
          });
        }
      }
      for (let x = 0; x < this.initialModules.length; x++) {
        if (this.modules.indexOf(this.initialModules[x]) === -1) {
          let moduleId = this.initialModules[x].id;
          let foreignKeyId = this.foreignKey.filter(function(el) {
            return el.moduleId === moduleId;
          });
          await Api().put("/organisationModule/" + foreignKeyId[0].id, {
            isActive: false,
            isDeleted: true
          });
          await Api().get('/modules/'+moduleId).then(response=>{
              let subs = response.data.moduleSubmodules
              for (let a =0; a<response.data.moduleSubmodules.length;a++){
                try {
                  Api()
              .get('/routePermission/modulesubmodule/'+response.data.moduleSubmodules[a].id+'/'+this.$route.params.organisationId,{
                orgToken: this.organisationDetail.token
              }).then(result=>{
                for (let b=0;b<result.data.length;b++){
                  Api()
                  .put('/routePermission/'+result.data[b].id,{
                    isActive: false,
                    isDeleted: true
                  })
                }
              })
                } catch {
                  console.log('Error with moduleSubmoduleId: '+  response.data.moduleSubmodules[a].id)
                }
                
              }
          })
        }
      }
      this.fetchOrganisationInfo();
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
  async fetchContactTypes() {

       if(this.$store.state.currentOrg.org.isPrimaryOrganisation==true){
       Api()
        .get("/contactTypes")
        .then(response => {
          this.contactTypes = response.data
        });
      }  else{
           Api()
        .get("/contactTypes/activeIsp")
        .then(response => {
          this.contactTypes = response.data
        });
        }
    
    },
    initialize() {
      this.fetchOrganisationInfo();
      this.fetchUserRoles();
      this.getOrgTypes();
      this.fetchModules();
      this.fetchAllContacts();
      this.fetchOrgUserRoles();
      // this.getAllBills();
      // this.getAllXeroContacts();
      // this.getOrgBridgeTemplates()
      // this.getBridgeTemplates()
      // this.getZhoneTrafficProfiles()
      // this.getDeviceMakes()
      this.fetchContactTypes()
    },
    routerLinkToDetails(item) {
      this.$router.push({ path: "/modules/" + item.id });
    },
    getOrgBridgeTemplates(){
      Api().get('/organisationBridgeTemplate/byCustomer/'+this.$route.params.organisationId)
      .then(response=>{
        this.organisationBridgeTemplates=response.data
      })
    },
    async getBridgeTemplates(){
      await Api()
      .get('/bridgeTemplate')
      .then(response=>{
       this.bridgeTemplates = response.data
      })
    },

    async saveBridgeItem(){
      // this.item.tpIndex = this.selectedPorts.join(',')
      // this.selectedPorts = []
      await Api()
      .post('/organisationBridgeTemplate', this.item)
      .then(response=>{
        this.getOrgBridgeTemplates()
        this.item={}
        this.addBridgeItem=false
      })
    },
    async updateBridgeItem(){
      // this.item.tpIndex = this.selectedPorts.join(',')
      // this.selectedPorts = []
      await Api()
      .put('/organisationBridgeTemplate/'+this.item.id, this.item)
      .then(response=>{
        this.getOrgBridgeTemplates()
        this.item={}
        this.addBridgeItem=false
      })
    },
    async deleteBridgeItem(item){
      confirm("Are you sure you would like to remove this template?")&&
      Api().put('/organisationbridgeTemplate/'+item.id, {
        isActive: false, isDeleted: true
      }).then(response=>{
        this.getOrgBridgeTemplates()
      })
    },

    async getZhoneTrafficProfiles(){
      await Api()
      .get('/zhoneTrafficProfile')
      .then(response=>{
       this.zhoneTrafficProfiles = response.data
      })
    },
    async getDeviceMakes(){
      Api()
      .get('/deviceMakes')
      .then(response=>{
        this.deviceMakes = response.data
      })
    },
    generateOrganisationToken(item){
      Api()
      .post('/orgToken',{
        id: item.id,
        name: item.name,
        description: item.description
      })
      .then(response=>{
        this.organisationDetail.token=response.data.token
        Api()
        .put('/organisation/'+item.id,{
          token: this.organisationDetail.token
        })
      })
    },
    removeContactFromOrg(item){
      confirm("Are you sure you would like to remove this contact from the organisation?")&&
      Api()
      .put('/organisationContact/'+item.id,{
        isActive: false,
        isDeleted: true
      })
      .then(response=>{
        this.fetchOrganisationInfo()
      })
    }
  }
};
</script>
<style>
.Planned {
  border-left: solid #d61212;
}
.Ongoing {
  border-left: 4px solid #eb780c;
}
.Complete {
  border-left: 4px solid #5eb110;
}
.Live {
  border-left: 4px solid #5eb110;
}
</style>
